import { useSyncExternalStore } from 'react'

const SESSION_TOKEN_KEY = 'session_token'

function getSnapshot(): string | null {
  return localStorage.getItem(SESSION_TOKEN_KEY)
}

function subscribe(callback: () => void): () => void {
  window.addEventListener('auth:change', callback)
  window.addEventListener('storage', callback)
  return () => {
    window.removeEventListener('auth:change', callback)
    window.removeEventListener('storage', callback)
  }
}

export function useAuth() {
  const token = useSyncExternalStore(subscribe, getSnapshot)
  return {
    isLoggedIn: !!token,
    token,
  }
}
